export default __webpack_public_path__ + "static/media/KZ.T.13.2472.f1e5e5af.svg";